import { useApplicantsStore } from "@/modules/store/applicantsStore";
import { useBusinessInfoStore } from "@/modules/store/businessInfoStore";
import { useConversationStore } from "@/modules/store/conversationStore";
import { useDraftJobStore } from "@/modules/store/draftJobStore";
import { useEditJobStore } from "@/modules/store/jobEditStore";
import { useJobManagerStore } from "@/modules/store/jobManagerStore";
import { useNotificationStore } from "@/modules/store/notificationStore";

export function resetAllBusinessStores() {
  useApplicantsStore.getState().reset();
  useBusinessInfoStore.getState().reset();
  useConversationStore.getState().reset();
  useDraftJobStore.getState().reset();
  useEditJobStore.getState().reset();
  useJobManagerStore.getState().reset();
  useNotificationStore.getState().reset();
}
